// This file can be replaced during build by using the `fileReplacements` array.
// When building for production, this file is replaced with `environment.prod.ts`.

export const environment = {
    production: true,
    env: 'staging',

    gatewayUrl: 'https://beta-student-api.thirdspacelearning.com/v1/api',

    rudderStackWriteKey: '2sDAVTfWR7XFSuxV8bBGhKj2R4W',
    rudderStackDataPlane: 'https://beta-aiven-api.thirdspacelearning.com/v1',
    rudderstackApiUrl: 'https://rudderstack-api.thirdspacelearning.com',

    ddRumAppId: '30924315-bee5-4353-a1b4-3889d35e6d61',
    ddRumClientToken: 'pub1438bcb2d50cd7d429ec54ebb5a3a59e',
    ddRumServiceName: 'student-experience---staging',

    keycloakUrl: 'https://nonprod-login.thirdspacelearning.com',
    keycloakRealm: 'staging',
    keycloakClientId: 'student-client',

    launchDarklyKey: '65c3877b9de2620f07deee88',
};
